import {
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  HostListener,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ActivatedRoute, Router } from "@angular/router";
import { AppState, stateGetter } from "../store/state/app.state";
import { Dictionary } from "highcharts";
import { debounceTime } from "rxjs/operators";
import {
  SetDisplay,
  SetCollapsed,
  SetDisabled,
  SetSelectedWatchlist,
  SetLeftPanelData,
} from "../store/actions/global.actions";
import { LeftPanel } from "../store/models/global.model";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { NzMessageService } from "ng-zorro-antd/message";
import { CompanyDataService } from "../company-page/company-data.service";
import { AppService } from "src/app/app.service";
import { UntypedFormControl } from "@angular/forms";
import { SuggestedChartDetails } from "../store/models/charts-page.model";
import { SetSuggestedChartDetails } from "../store/actions/charts-page.actions";
import { HttpClient } from "@angular/common/http";
import { PageParams } from "../store/models/navigation-settings.model";
import { Subscription } from "rxjs";
import { INDUSTRY_PAGE_INFO } from "src/app/sectors-and-industries-page/sector-and-industry-page-constants";
import { ComparativeAnalysisPopoverContentService } from "../shared/comparative-analysis-popover-content/comparative-analysis-popover-content.service";

import {
  VAIconRegistryService,
  chevronRight,
  infoCircle,
  search,
  plus,
  ellipsisVertical,
} from "@va/core-library/icons";
import { GlobalSubheaderDataService } from "../global-subheader/global-subheader-data.service";
@Component({
  selector: "app-left-panel",
  templateUrl: "./left-panel.component.html",
  styleUrls: ["./left-panel.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LeftPanelComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  loading = true;
  panelData: any = {};
  panelDataCopy: any = {};
  key = "";
  type = "";
  pageName = "";
  isBloombergTicker = false;
  faHome = faHome;
  legacyUrl = `${window.caUrl}/app`;
  apiUrl: string = window.apiUrl;
  isCompanyCovered: boolean;
  showError = false;
  usersnapJsKey: string;
  snapEmail: string;
  userName: string;
  events_access: boolean;
  leftPanelData = 0;
  normalizeForecastBtnText = "";
  selectedWatchlist: Dictionary<string | number>;
  searchQuery: UntypedFormControl = new UntypedFormControl();
  visibleComparativePo = false;
  excludedPages: Array<string> = [
    "sectors_industries",
    "allbrokers",
    "sector",
    "broker",
    "analyst",
    "models",
    "industry",
    "allcompany",
    "entitlements",
    "home",
    "alert_settings",
    "research_document",
    "labs",
    "embargomanagement",
    "apitutorials",
    "exceladdin",
    "biopharma",
    "biopharma-database",
    "biopharma-drug",
    "search-page",
    "templatelibrary",
    "testing-stub",
  ];
  showReturnToHomeLink: Array<string> = ["mex", "surprise", "revisions"];
  firstWatchlistId: number;
  pbSearchedMatches: any;
  selectedTabId: number;
  selectedPbTab: any;
  selectedChartId: string;
  comparativePageType: string;
  suggestedChartIndex: any;
  pageNavParams: PageParams;
  pageNavParamsLP: PageParams;
  pageNavSubscription: Subscription;
  leftPanelDataSubscription: Subscription;
  getLeftPanelDataSubscription: Subscription;
  comparativeAnalysisPopoverSubscription: Subscription;
  keepSelectedWatchlist = false;
  currentChartData = null;
  currentCompData = null;
  currentComparativeData = null;
  comparativeAnalysisPopoverData;
  paTicker: string;
  selectedIndustryMetricsMenuItem: string;

  constructor(
    private store: Store<AppState>,
    private dataService: GlobalSubheaderDataService,
    private message: NzMessageService,
    private companyService: CompanyDataService,
    private appService: AppService,
    private comparativeAnalysisPopoverContentService: ComparativeAnalysisPopoverContentService,
    private route: ActivatedRoute,
    public router: Router,
    private http: HttpClient,
    private iconRegistry: VAIconRegistryService,
  ) {
    store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.usersnapJsKey = data.usersnapJsKey;
        this.snapEmail = data.userDetails ? data.userDetails.email : "";
        this.userName = data.userName;
        this.events_access = data.events_access;
      });
    this.iconRegistry.registerIcons([
      chevronRight,
      search,
      infoCircle,
      plus,
      ellipsisVertical,
    ]);
  }

  @HostListener("window:popstate")
  onPopState() {
    if (this.pageName === "industry_metrics") {
      const industryMenuItem = decodeURIComponent(
        window.location.pathname.split("/")[3],
      );
      if (this.selectedIndustryMetricsMenuItem !== industryMenuItem) {
        this.selectedIndustryMetricsMenuItem =
          industryMenuItem || INDUSTRY_PAGE_INFO.kpis.shortName;
      }
    }
  }

  ngOnInit(): void {
    this.store
      .select(stateGetter("globalSubheader", "pageName"))
      .subscribe((data: string) => {
        const hasLeftPanel = !this.excludedPages.includes(data);
        if (this.searchQuery.value !== "") {
          this.searchQuery.setValue("");
        }
        if (hasLeftPanel) {
          this.store.dispatch(new SetDisplay(true));
          const currentType = window.location.pathname.split("/")[2];
          const currentKey = decodeURIComponent(
            decodeURIComponent(window.location.pathname.split("/")[3]),
          );
          const bloombergtickerType = window.location.pathname.split("/")[4];
          this.panelData = {};
          this.loading = true;
          if (
            data !== "" &&
            (this.pageName !== data ||
              this.type !== currentType ||
              this.key !== currentKey)
          ) {
            this.pageName = data;
            if (this.pageName === "watchlist") {
              this.type = "watchlist";
              this.key = "watchlist";
            } else if (this.pageName === "charts") {
              this.type = "charts";
              this.key = "charts";
              this.selectedChartId =
                window.location.pathname.split("/")[2] || null;
            } else if (this.pageName === "comps") {
              this.type = "comparable";
              this.key = "comptables";
              this.selectedTabId = parseInt(currentKey, 10);
              if (this.searchQuery.value !== "") {
                this.searchQuery.setValue("");
              }
            } else if (this.pageName === "industry_metrics") {
              this.type = "industry_metrics";
              this.key = "industry_metrics";
              const industryMenuItem = decodeURIComponent(
                window.location.pathname.split("/")[3],
              );
              this.selectedIndustryMetricsMenuItem =
                industryMenuItem || INDUSTRY_PAGE_INFO.kpis.shortName;
            } else if (this.pageName === "comparative-analysis") {
              this.type = "comparative_analysis";
              this.key = "comparative_analysis";
              this.selectedTabId = parseInt(currentKey, 10);
            } else {
              // suport for ticker
              this.type = "company";
              if (
                this.pageName === "research" ||
                this.pageName === "company" ||
                this.pageName === "mex" ||
                this.pageName === "revisions" ||
                this.pageName === "surprise" ||
                this.pageName === "analystdashboard" ||
                this.pageName === "events" ||
                this.pageName === "vsconsensus" ||
                this.pageName === "valuation" ||
                this.pageName === "tpr" ||
                this.pageName === "nav"
              ) {
                this.key = currentType;
                this.isBloombergTicker =
                  bloombergtickerType !== undefined ? true : false;
              }
            }
            this.leftPanelDataChanged();
            if (this.type === "company" && this.paTicker !== this.key) {
              this.paTicker = this.key;

              if (this.comparativeAnalysisPopoverSubscription) {
                this.comparativeAnalysisPopoverSubscription.unsubscribe();
              }
              this.comparativeAnalysisPopoverSubscription =
                this.comparativeAnalysisPopoverContentService
                  .getComparativeAnalysisPopoverData(this.key)
                  .subscribe((response) => {
                    if (response.status === "success") {
                      this.comparativeAnalysisPopoverData = response.data;
                    }
                  });
            }
          }
        } else {
          if (this.getLeftPanelDataSubscription) {
            this.getLeftPanelDataSubscription.unsubscribe();
          }
          this.store.dispatch(new SetDisplay(false));
        }
      });

    this.store
      .select(stateGetter("globalSubheader", "ticker"))
      .subscribe((ticker: string) => {
        const hasLeftPanel = !this.excludedPages.includes(this.type);
        if (hasLeftPanel) {
          this.store.dispatch(new SetDisplay(true));
          const currentKey = decodeURIComponent(
            decodeURIComponent(window.location.pathname.split("/")[2]),
          );

          if (ticker !== "" && this.key !== ticker) {
            this.key = currentKey;
            this.leftPanelDataChanged();
          }
          const peerTicker = this.key ? this.key : currentKey;
          if (this.type === "company" && this.paTicker !== peerTicker) {
            this.paTicker = peerTicker;

            if (this.comparativeAnalysisPopoverSubscription) {
              this.comparativeAnalysisPopoverSubscription.unsubscribe();
            }
            this.comparativeAnalysisPopoverSubscription =
              this.comparativeAnalysisPopoverContentService
                .getComparativeAnalysisPopoverData(this.key)
                .subscribe((response) => {
                  if (response.status === "success") {
                    this.comparativeAnalysisPopoverData = response.data;
                  }
                });
          }
        } else {
          this.store.dispatch(new SetDisplay(false));
        }
      });

    this.pageNavSubscription = this.store
      .select(stateGetter("navigationSettings", "pageParams"))
      .subscribe((pageParams: PageParams) => {
        this.pageNavParams = pageParams;

        if (!pageParams || !pageParams.ticker) {
          return;
        }

        if (
          this.pageNavParamsLP &&
          this.pageNavParamsLP.ticker === pageParams.ticker
        ) {
          return;
        }

        this.pageNavParamsLP = pageParams;
        const hasLeftPanel =
          Boolean(this.type) && !this.excludedPages.includes(this.type);

        if (hasLeftPanel) {
          this.store.dispatch(new SetDisplay(true));
          this.leftPanelDataChanged();
        } else {
          this.store.dispatch(new SetDisplay(false));
        }
      });

    this.appService.updateLeftPanelSource$.subscribe((options) => {
      if (this.pageName === "charts") {
        this.selectedChartId = window.location.pathname.split("/")[2] || null;
        if (options && options.dataRefresh === "true") {
          this.getLeftPanelData("", "charts", "", false, "", true, true);
          if (options.currentChartData || options.currentChartData === null) {
            this.currentChartData = options.currentChartData;
          }
        } else {
          if (options && options.suggestedChartIndex) {
            this.suggestedChartIndex = options.suggestedChartIndex;
          }
          if (
            options &&
            (options.currentChartData || options.currentChartData === null)
          ) {
            if (options.currentChartData !== null) {
              if (
                this.currentChartData !== null &&
                options.currentChartData.name === ""
              ) {
                options.currentChartData.name = this.currentChartData.name;
              }
              this.currentChartData = {
                ...this.currentChartData,
                name:
                  options.currentChartData.name !== undefined
                    ? options.currentChartData.name
                    : this.currentChartData.name,
                params:
                  options.currentChartData.params !== undefined
                    ? options.currentChartData.params
                    : this.currentChartData.params,
                selected:
                  options.currentChartData.selected !== undefined
                    ? options.currentChartData.selected
                    : this.currentChartData.selected,
              };
            } else {
              this.currentChartData = options.currentChartData;
            }
          }
        }
      }
      if (this.pageName === "comparative-analysis") {
        this.comparativePageType =
          window.location.pathname.split("/")[2] || null;
        if (options && options.dataRefresh === "true") {
          this.getLeftPanelData(
            "",
            "comparative_analysis",
            "",
            false,
            "",
            true,
            true,
          );
          if (
            options.currentComparativeData ||
            options.currentComparativeData === null
          ) {
            this.currentComparativeData = options.currentComparativeData;
          }
        } else {
          const tabId = decodeURIComponent(
            decodeURIComponent(window.location.pathname.split("/")[3]),
          );
          this.selectedTabId = parseInt(tabId, 10);
          if (tabId === "undefined") {
            this.selectedTabId = null;
          }
          if (
            options &&
            (options.currentComparativeData ||
              options.currentComparativeData === null)
          ) {
            if (options.currentComparativeData !== null) {
              if (
                this.currentComparativeData !== null &&
                options.currentComparativeData.name === ""
              ) {
                options.currentComparativeData.name =
                  this.currentComparativeData.name;
              }
              this.currentComparativeData = {
                ...this.currentComparativeData,
                name:
                  options.currentComparativeData.name !== undefined
                    ? options.currentComparativeData.name
                    : this.currentComparativeData.name,
                params:
                  options.currentComparativeData.params !== undefined
                    ? options.currentComparativeData.params
                    : this.currentComparativeData.params,
                selected:
                  options.currentComparativeData.selected !== undefined
                    ? options.currentComparativeData.selected
                    : this.currentComparativeData.selected,
              };
            } else {
              this.currentComparativeData = options.currentComparativeData;
            }
          }
        }
      }
      if (this.pageName === "comps") {
        if (this.searchQuery.value !== "") {
          this.searchQuery.setValue("");
        }
        if (options.dataRefresh === "true") {
          this.getLeftPanelData(
            this.key,
            "comparable",
            "",
            false,
            "",
            true,
            false,
          );
          if (options.currentCompData || options.currentCompData === null) {
            this.currentCompData = options.currentCompData;
          }
        } else {
          const tabId = decodeURIComponent(
            decodeURIComponent(window.location.pathname.split("/")[3]),
          );
          this.selectedTabId = parseInt(tabId, 10);
          if (tabId === "undefined") {
            this.selectedTabId = null;
          }
          if (
            options &&
            (options.currentCompData || options.currentCompData === null)
          ) {
            if (options.currentCompData !== null) {
              if (
                this.currentCompData !== null &&
                options.currentCompData.name === ""
              ) {
                options.currentCompData.name = this.currentCompData.name;
              }
              this.currentCompData = {
                ...this.currentCompData,
                name:
                  options.currentCompData.name !== undefined
                    ? options.currentCompData.name
                    : this.currentCompData.name,
                params:
                  options.currentCompData.params !== undefined
                    ? options.currentCompData.params
                    : this.currentCompData.params,
                selected:
                  options.currentCompData.selected !== undefined
                    ? options.currentCompData.selected
                    : this.currentCompData.selected,
              };
            } else {
              this.currentCompData = options.currentCompData;
            }
          }
        }
      }
      if (this.type === "watchlist") {
        this.keepSelectedWatchlist = true;
        this.selectedWatchlist = { watchlistId: options.watchlistId };
        this.leftPanelDataChanged();
      }
      if (this.pageName === "industry_metrics") {
        this.selectedIndustryMetricsMenuItem =
          options && options.shortName
            ? options.shortName
            : INDUSTRY_PAGE_INFO.kpis.shortName;
      }
    });

    this.searchQuery.valueChanges
      .pipe(debounceTime(500))
      .subscribe((text: any) => {
        if (this.panelData && this.type === "comparable") {
          if (
            this.panelData.data &&
            this.panelDataCopy &&
            this.panelDataCopy.data &&
            (text.length >= 2 || text.length === 0)
          ) {
            this.panelData.data[0].values =
              this.panelDataCopy.data[0].values.filter((item) => {
                return item.label
                  .toLowerCase()
                  .includes(this.searchQuery.value.toLowerCase());
              });

            const c = JSON.parse(
              JSON.stringify(this.panelDataCopy.data[1].values),
            );
            this.searchValues(this.panelDataCopy.data[1].values, c);
            this.pbSearchedMatches = JSON.parse(JSON.stringify(c));

            for (let i = 0; i < this.pbSearchedMatches.length; i++) {
              this.pbSearchedMatches[i].values = c[i].values.filter((item) => {
                return item.values.length > 0;
              });
            }
            const result = this.pbSearchedMatches.filter((item) => {
              return item.values.length > 0;
            });
            this.panelData.data[1].values = JSON.parse(JSON.stringify(result));
            this.prebuiltCompSelection();
          }
        }
      });
  }

  getLeftPanelData(
    companytTicker: string,
    type: string,
    industryName: string,
    isBloombergTicker: boolean,
    watchlist: string,
    display: boolean,
    hideLoader: boolean,
  ) {
    let ticker = companytTicker ? `&ticker=${companytTicker}` : "";
    if (
      type === "comparable" ||
      type === "industry_metrics" ||
      type === "comparative_analysis"
    ) {
      ticker = ``;
    }
    const industry = industryName
      ? `&industryName=${encodeURIComponent(industryName)}`
      : "";
    const bloombergTicker = isBloombergTicker ? `&tickertype=b` : "";
    if (!hideLoader) {
      this.loading = true;
    }
    if (this.getLeftPanelDataSubscription) {
      this.getLeftPanelDataSubscription.unsubscribe();
    }
    this.getLeftPanelDataSubscription = this.http
      .get(
        `${window.apiUrl}/api/get_left_panel_data?type=${type}${ticker}${industry}${bloombergTicker}`,
      )
      .subscribe((leftPanel) => {
        const payload = {
          respData: leftPanel,
          key:
            type === "charts"
              ? "charts"
              : ticker
                ? this.key
                : industryName
                  ? industryName
                  : watchlist
                    ? watchlist
                    : this.key,
          display: display,
        };
        this.store.dispatch(new SetLeftPanelData(payload));
      });
  }

  ngOnDestroy() {
    if (this.pageNavSubscription) {
      this.pageNavSubscription.unsubscribe();
    }
    if (this.leftPanelDataSubscription) {
      this.leftPanelDataSubscription.unsubscribe();
    }
    if (this.getLeftPanelDataSubscription) {
      this.getLeftPanelDataSubscription.unsubscribe();
    }

    if (this.comparativeAnalysisPopoverSubscription) {
      this.comparativeAnalysisPopoverSubscription.unsubscribe();
    }
  }

  leftPanelDataChanged() {
    const hasLeftPanel = !this.excludedPages.includes(this.type);
    let forceReload = this.key === "charts";
    if (this.leftPanelDataSubscription) {
      this.leftPanelDataSubscription.unsubscribe();
    }
    this.leftPanelDataSubscription = this.store
      .select(stateGetter("leftPanel", "data"))
      .subscribe((data: LeftPanel) => {
        this.key =
          (this.pageNavParamsLP &&
            this.pageName === "mex" &&
            this.pageNavParamsLP.ticker) ||
          this.key;
        if (!forceReload && data[this.key]) {
          if (this.pageName === "mex") {
            // adding this special handling for collapse state of left panel
            this.getLeftPanelDataSubscription = this.http
              .get(
                `${window.apiUrl}/api/get_left_panel_data?type=mex&ticker=${this.key}`,
              )
              .subscribe((response: any) => {
                this.store.dispatch(
                  new SetCollapsed(!response.extras.leftPanelState),
                );
              });
          }
          this.panelData = JSON.parse(JSON.stringify(data[this.key]));
          if (this.key !== "charts") {
            this.currentChartData = null;
          }
          const _key = decodeURIComponent(
            decodeURIComponent(window.location.pathname.split("/")[2]),
          );
          if (_key !== "current") {
            this.currentCompData = null;
          }
          if (this.type === "watchlist") {
            this.showEnabledLeftPanel();
          } else if (this.type === "company") {
            this.isCompanyCovered = this.panelData.extras.isCoveredCompany;
            if (
              this.pageName === "company" &&
              !this.isCompanyCovered &&
              !this.isCollapsed
            ) {
              this.showDisabledLeftPanel();
            } else {
              this.showEnabledLeftPanel();
            }
            if (this.panelData.extras.ticker_prioritized) {
              this.normalizeForecastBtnText = "Requested";
            } else {
              this.normalizeForecastBtnText = "Prioritize";
            }
          } else if (this.type === "comparable") {
            this.panelDataCopy = data[this.key];
            const tabId = decodeURIComponent(
              decodeURIComponent(window.location.pathname.split("/")[3]),
            );
            this.selectedTabId = parseInt(tabId, 10);
            if (tabId === "undefined") {
              this.selectedTabId = null;
            }
            this.prebuiltCompSelection();
            this.store.dispatch(new SetCollapsed(false));
            this.store.dispatch(new SetDisabled(false));
            this.store.dispatch(new SetDisplay(true));
            if (this.currentCompData !== null) {
              this.currentCompData = {
                ...this.currentCompData,
                selected: this.selectedTabId === null,
              };
            }
          } else if (this.type === "charts") {
            this.selectedChartId = window.location.pathname.split("/")[2];
            if (this.currentChartData !== null) {
              this.currentChartData = {
                ...this.currentChartData,
                selected: this.selectedChartId === "current",
              };
            }
            this.store.dispatch(new SetCollapsed(false));
            this.store.dispatch(new SetDisabled(false));
            this.store.dispatch(new SetDisplay(true));
          } else {
            this.store.dispatch(new SetCollapsed(false));
            this.store.dispatch(new SetDisabled(false));
          }
          this.showError = this.panelData.status !== "success";
          this.loading = false;
        } else {
          forceReload = false;
          this.isCollapsed = false;
          const payload: Dictionary<string | boolean> = {
            type: this.type,
            display: hasLeftPanel,
            isCollapsed: false,
          };
          if (this.type === "watchlist") {
            payload["watchlist"] = this.key;
          } else if (this.type === "industry") {
            payload["industryName"] = this.key;
          } else if (this.type === "charts") {
            payload["ticker"] = "";
          } else {
            payload["ticker"] = this.key;
          }
          payload["isBloombergTicker"] =
            this.pageName === "revisions" && this.isBloombergTicker
              ? true
              : false;
          this.getLeftPanelData(
            payload.ticker as string,
            payload.type as string,
            payload.industryName as string,
            payload.isBloombergTicker as boolean,
            payload.watchlist as string,
            payload.display as boolean,
            false,
          );
        }
      });
  }

  showDisabledLeftPanel() {
    this.store.dispatch(new SetDisplay(true));
    this.store.dispatch(new SetCollapsed(true));
    this.store.dispatch(new SetDisabled(true));
  }

  showEnabledLeftPanel() {
    this.store.dispatch(new SetDisplay(true));
    if (this.pageName !== "mex") {
      this.store.dispatch(new SetCollapsed(false));
    }
    this.store.dispatch(new SetDisabled(false));
  }

  switchChart(param1: any) {
    const newDetails: SuggestedChartDetails = {
      chartName: param1.label,
      chartTypeId: param1.chart_type_id,
      lineId: param1.line_id,
      periods: param1.periods,
      periodType: param1.periodType,
      otherPeriods: param1.otherPeriods,
      is_annual_selected: param1.is_annual_selected,
      ticker: param1.ticker,
      index: `${param1.index}`,
      peers: param1.company_peers.map((p) => p.ticker),
    };
    this.store.dispatch(new SetSuggestedChartDetails(newDetails));
    this.suggestedChartIndex = `${param1.index}`;
  }

  switchWatchlist() {
    // setting selected watchlist data
    const payload = {
      ...this.selectedWatchlist,
    };
    this.store.dispatch(new SetSelectedWatchlist(payload));
  }

  onClickIndustryCompTable(industryName) {
    if (!this.panelData.data[0].values.industryPeerAnalysisEnabled) {
      return;
    }
    window.location.href = `${
      this.legacyUrl
    }/industryComps/${encodeURIComponent(industryName)}`;
  }
  onClickComparableAnalysis(tabId, industryName) {
    if (!this.panelData.data[0].values.industryPeerAnalysisEnabled) {
      return;
    }
    window.location.href = `${
      this.legacyUrl
    }/industryanalysis/peeranalysis/${encodeURIComponent(
      industryName,
    )}/${tabId}`;
  }

  onClickIndustryHomeTable(industryName) {
    window.location.href = `${this.legacyUrl}/industryHome/${encodeURIComponent(
      industryName,
    )}`;
  }

  onClickMenu(view: string, param1: any, param2?: any) {
    if (this.type === "company") {
      //Adding a page check here to prevent calling it in 3 places below
      if (this.pageName === "mex") {
        window.dispatchEvent(
          new CustomEvent("changeBreadCrumbDetailFromLPForMex", {
            detail: {
              tabName: param1.label,
              cut: view,
              source: param2.header,
              shortName: param1.shortName,
            },
          }),
        );
      }

      if (param1.label === "Peer Analysis") {
        this.onClickCompanyPeerAnalysis(
          !this.panelData.data[0].values.companyPeerAnalysisEnabled,
          this.panelData.data[0].values.tabId,
        );
      } else if (param2.header === "VA Comp Table") {
        this.onClickComps(param1.tabid);
      } else if (param1.label === "QC Dashboard") {
        this.router.navigate([`/company/${this.key}/analystdashboard`]);
      }
    } else if (this.type === "industry") {
      switch (param2.header) {
        case "Related Industries":
          this.onClickIndustryHomeTable(param1.label);
          break;
        case "VA Comps Table":
          this.onClickComps(param1.tabid);
          break;
        case "Peer Analysis":
          this.onClickIndustryPeerAnalysis(
            !this.panelData.data[0].values.industryPeerAnalysisEnabled,
            param1.tabid,
          );
          break;
        default:
          this.router.navigateByUrl("/home");
      }
    } else if (this.type === "industry_metrics") {
      const currentPath = window.location.pathname;
      if (typeof currentPath === "string") {
        let industryId = decodeURIComponent(currentPath.split("/")[2]);
        if (industryId === undefined || industryId === "undefined") {
          industryId = "166";
        }
        let industrySubGroupId = null;
        const queryString = window.location.search;
        if (queryString) {
          const urlParams = new URLSearchParams(queryString);
          if (urlParams) {
            industrySubGroupId = urlParams.get("subgroup");
          }
        }
        let industryAnalysisUrl = `/industry/${industryId}/${param1.shortName}`;
        if (industrySubGroupId) {
          industryAnalysisUrl += `?subgroup=${industrySubGroupId}`;
        }
        this.router.navigateByUrl(industryAnalysisUrl);
        this.selectedIndustryMetricsMenuItem = param1.shortName;
      }
    } else if (this.type === "watchlist") {
      this.router.navigateByUrl(`/watchlist/${param1.watchlistId}`);
      this.switchWatchlist();
    } else if (this.type === "charts") {
      if (param2.header === "Custom Charts") {
        this.router.navigate([`/charts/${param1.chart_id}`]);
        this.selectedChartId = param1.chart_id.toString();
      } else {
        this.router
          .navigate([`/charts/suggested`], {
            state: {
              fromLP: true,
            },
          })
          .then(() => {
            this.selectedChartId = "suggested";
            this.switchChart(param1);
          });
      }
    } else if (this.type === "comparative_analysis") {
      if (param2.header === "Saved Analysis") {
        let urlToNavigate = "/comparative-analysis/user";
        if (param1.tab_id) {
          this.selectedTabId = param1.tab_id;
          urlToNavigate += `/${param1.tab_id}`;
          this.router.navigateByUrl(urlToNavigate);
        }
      }
    }
  }

  onClickIndustryPeerAnalysis(isDisabled, tabId: string) {
    if (isDisabled) return;
    window.location.href = `${
      this.legacyUrl
    }/industryanalysis/peeranalysis/${encodeURIComponent(this.key)}/${tabId}`;
  }

  onClickCompanyPeerAnalysis(isDisabled, tabId: string) {
    if (isDisabled) return;
    window.location.href = `${this.legacyUrl}/peerAnalysis/${encodeURIComponent(
      this.key,
    )}/${tabId}`;
  }

  onClickComps(tabId: string) {
    window.location.href = `${this.legacyUrl}/comps/${tabId ? tabId : ""}`;
  }

  onClickCoverage(sectorName: string) {
    window.location.href = `${
      this.legacyUrl
    }/industry_page/${encodeURIComponent(sectorName)}/${encodeURIComponent(
      this.key,
    )}`;
  }

  isItemGroup(child: any): boolean {
    return child.values;
  }

  onClickPrioritize() {
    window.Usersnap.init({
      button: { isHidden: true },
    });
    window.Usersnap.on("open", (event) => {
      event.api.setValue("custom", {
        email: this.snapEmail,
        username: this.userName,
        ticker: this.key,
      });
      event.api.setValue("email", this.snapEmail);
      event.api.setValue(
        "comment",
        "Please initiate coverage on this company.",
      );
    });
    window.Usersnap.on("submit", () => {
      this.companyService.trackUserRequest(this.key).subscribe(
        (respObject) => {
          if (respObject.status === "success") {
            //success toastr
            this.message.warning(
              `We have received your request and will prioritize accordingly. You will receive an email notification once the normalization is completed.`,
              {
                nzDuration: 2000,
              },
            );

            this.normalizeForecastBtnText = "Requested";
          } else {
            // error toastr
            this.message.error(
              `Error: Failed to recieve request. Please try again later.`,
              {
                nzDuration: 2000,
              },
            );
          }
        },
        () => {
          //error toastr
          this.message.error(
            `Error: Failed to recieve request. Please try again later.`,
            {
              nzDuration: 2000,
            },
          );
        },
      );
    });
    setTimeout(() => {
      window.Usersnap.open();
    }, 1000);
  }

  onLineitemChange(param: any) {
    const source =
      param.parent.view.toLowerCase() === "sar"
        ? `/${param.parent.sourceShortname}`
        : "";
    // window.location.href = `${this.legacyUrl}/mex/${param.parent.tabshortname}/${param.parent.view}/${this.key}${source}?dpid=${param.id}`;
    this.router.navigate(
      [
        `/mex/${this.key}/${param.parent.view}/${param.parent.tabshortname}${source}`,
      ],
      { queryParams: { dpid: param.id } },
    );
  }

  redirectToTab(param: any) {
    if (param.level === 2) {
      const source =
        param.view.toLowerCase() === "sar" ? `/${param.sourceShortname}` : "";
      this.router.navigate([
        `/mex/${this.key}/${param.view}/${param.tabshortname}${source}`,
      ]);
      // window.location.href = `${this.legacyUrl}/mex/${param.tabshortname}/${param.view}/${this.key}${source}`;
    }
  }

  navigateComps(item, sectionIndex) {
    this.selectedTabId = item.shortName;
    if (sectionIndex === 0) {
      this.router.navigate([`/comptables/user/${item.tab_id}`]);
    } else {
      this.router.navigate([`/comptables/system/${item.shortName}`]);
    }
  }

  navigateCurrent(route, param) {
    this.router.navigate([route], { queryParams: param });
  }

  prebuiltCompSelection() {
    this.panelData.data[1].values.forEach((sector) => {
      return sector.values.forEach((industry) => {
        const isIndustry = industry.values.filter((comp) => {
          if (comp.shortName === this.selectedTabId) this.selectedPbTab = comp;
          return comp.shortName === this.selectedTabId;
        });
        if (isIndustry.length) {
          sector["open"] = true;
          industry["open"] = true;
        } else {
          if (!sector["open"]) {
            sector["open"] = false;
          }

          industry["open"] = false;
        }
        return isIndustry;
      });
    });
  }

  // CompsSearchKeyChange(): void {
  //   this.searchQuery.valueChanges.pipe(debounceTime(500))
  //       .subscribe((text: any) => {
  //         if(text.length >=2){
  //           this.panelData.data[0].values = this.panelDataCopy.data[0].values.filter(
  //             (item) => {
  //               return item.label
  //                 .toLowerCase()
  //                 .includes(this.searchQuery.value.toLowerCase());
  //             }
  //           );

  //           const c = JSON.parse(JSON.stringify(this.panelDataCopy.data[1].values));
  //           this.searchValues(this.panelDataCopy.data[1].values, c);
  //           this.pbSearchedMatches = JSON.parse(JSON.stringify(c));

  //           for (let i = 0; i < this.pbSearchedMatches.length; i++) {
  //             this.pbSearchedMatches[i].values = c[i].values.filter((item) => {
  //               return item.values.length > 0;
  //             });
  //           }
  //           const result = this.pbSearchedMatches.filter((item) => {
  //             return item.values.length > 0;
  //           });
  //           this.panelData.data[1].values = JSON.parse(JSON.stringify(result));
  //           this.prebuiltCompSelection();
  //         }

  //       });

  // }

  searchValues(arrCopy, arr) {
    for (let i = 0; i < arrCopy.length; i++) {
      if (arrCopy[i].values && Array.isArray(arrCopy[i].values[0].values)) {
        this.searchValues(arrCopy[i].values, arr[i].values);
      } else {
        arr[i].values = arrCopy[i].values.filter((item) => {
          return item.label
            .toLowerCase()
            .includes(this.searchQuery.value.toLowerCase());
        });
      }
    }
  }

  onMenuExpandStateChange(headerName: string, isExpanded) {
    let featureName = headerName.split(" ").join("_").toUpperCase();
    if (featureName.includes("STANDARDIZED")) {
      featureName += "_";
    }
    featureName += isExpanded ? "_EXPAND" : "_COLLAPSE";
    this.logUserAction(featureName);
  }

  logUserAction(feature) {
    this.appService.logUserAction(
      {},
      this.pageNavParams.ticker,
      this.pageNavParams.cut,
      feature,
      "",
      "" || this.pageNavParams.source,
      null,
    );
  }

  changeComparativeAnalysisVisibility(e) {
    this.visibleComparativePo = e;
  }

  createNew() {
    this.dataService.onAction("createCustomAnalysis");
  }

  actionOnTemplate(actionType, templateName, templateId = "") {
    const details = {
      action_type: actionType,
      template_name: templateName,
      template_id: templateId,
    };
    this.dataService.onTemplateAction(details);
  }
}
